module.exports = __webpack_public_path__ + "img/img-done.7bba9fe6.png";